// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"style_sub-title__Ar2he","methods":"style_methods__e4o_i","method":"style_method__hWvej","methodIcon":"style_method-icon___tiU6"};